// Buffer locale dei chunk audio: la registrazione sopravvive a crash e cadute di rete.
const DB_NAME = 'memorie';
const STORE = 'chunks';

function openDb(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      req.result.createObjectStore(STORE, { keyPath: ['recId', 'seq'] });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

function tx<T>(mode: IDBTransactionMode, fn: (store: IDBObjectStore) => IDBRequest<T>): Promise<T> {
  return openDb().then(
    (db) =>
      new Promise<T>((resolve, reject) => {
        const t = db.transaction(STORE, mode);
        const req = fn(t.objectStore(STORE));
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error);
      }),
  );
}

export type ChunkRow = { recId: string; seq: number; blob: Blob; sent: boolean };

export function saveChunk(row: ChunkRow): Promise<unknown> {
  return tx('readwrite', (s) => s.put(row));
}

export function markSent(recId: string, seq: number, blob: Blob): Promise<unknown> {
  return tx('readwrite', (s) => s.put({ recId, seq, blob, sent: true }));
}

export async function chunksFor(recId: string): Promise<ChunkRow[]> {
  const all = await tx<ChunkRow[]>('readonly', (s) =>
    s.getAll(IDBKeyRange.bound([recId, 0], [recId, Number.MAX_SAFE_INTEGER])),
  );
  return all.sort((a, b) => a.seq - b.seq);
}

export function deleteRecording(recId: string): Promise<unknown> {
  return tx('readwrite', (s) =>
    s.delete(IDBKeyRange.bound([recId, 0], [recId, Number.MAX_SAFE_INTEGER])),
  );
}

/** Blob unico per il riascolto locale (nessun bisogno del server). */
export async function localBlob(recId: string, mime: string): Promise<Blob | null> {
  const rows = await chunksFor(recId);
  if (rows.length === 0) return null;
  return new Blob(rows.map((r) => r.blob), { type: mime });
}
